import React from 'react';
import './footer.css';

const Footer = () => {
    return (
        <footer className='footer--wrapper'>
            <div className='footer--container'>
                <section>
                    © Benchmark 2021
                </section>
            </div>
        </footer>
    )
}

export default Footer
